import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ThemedJsonView from './ThemedJsonView';

// Collapsible JSON dump of a page's raw API data, shown to admins only
const RawDataPanel = ({ data }) => (
  <Accordion
    disableGutters
    elevation={0}
    // Only render the JSON tree while open: it can be thousands of nodes and would otherwise be rebuilt on every poll
    slotProps={{ transition: { unmountOnExit: true } }}
    sx={{
      border: "1px solid var(--c-border)",
      borderRadius: "16px !important",
      overflow: "hidden",
      "&:before": { display: "none" },
    }}
  >
    <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 2.5 }}>
      <Typography sx={{ fontSize: 14, fontWeight: 600, color: "var(--c-text-2)" }}>Raw data</Typography>
      <Typography sx={{ fontSize: 12, color: "var(--c-text-faint)", ml: 1, alignSelf: "center" }}>Admin only</Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ px: 2.5, borderTop: "1px solid var(--c-muted)", backgroundColor: "var(--c-subtle)" }}>
      <ThemedJsonView value={data} />
    </AccordionDetails>
  </Accordion>
);

export default RawDataPanel;
